{
    "titleTxt":"Manage Broadcast",
    "subHeadingTxt":"Create and see the Broadcasts",
    "paragraphText":"List of Broadcast messages for the academic year",
    "filterText":"Filter Broadcasts by: ",
    "allCategoriesText":"All Categories",
    "createText":"Create",
    "closebtnText":"Close",
    "srNoText":"Sr. No",
    "broadcastNameText":"Broadcast name",
    "broadcastDescText":"Broadcast description",
    "previewText":"Attachment",
    "popupHeadingText":"Create Broadcast",
    "broadcastSubjectText":"Broadcast subject:",
    "broadcastType":"Broadcast type: ",
    "requiredBroadcastType":"Broadcast type is required",
    "broadcastTypeALL":"ALL",
    "broadcastTypeSTAFFS":"STAFFS",
    "broadcastTypePARENTS":"PARENTS",
    "broadcastSubject":"Enter your broadcast subject",
    "requiredBroadcastSubject":"Broadcast subject is required and must be atleast 2 characters",
    "broadcastMessage":"Broadcast message:",
    "broadcastMessagePlaceholder":"Enter broadcast message",
    "broadcastMessagerequired":"Message is required and must be at least 3 characters",
    "priority":"Priority:",
    "priorityRequired":"Priority is required and must be true or false",
    "attachementFormatValidation":"Only PNG, JPG, JPEG and WEBP files are allowed",
    "attachementSizeValidation":"Attachement size must not exceed 25MB",
    "attachmentLabel":"Attachment:",
    "attachementNoteText":"Note: ",
    "attachmentNote":"Only images are allowed and image type should be png, jpeg, jpg and webp and size of image less then or equal to 25 MB.",
    "attchImageHeading":"Click to attach image",
    "selectedOptionText":"Select Broadcast type",
    "broadcastPriority":"Priority",
    "broadcastTypeCol":"Broadcast type",
    "createBroadcastSuccessMessage":"Broadcast created successfully",
    "BroadcastFailedToCreateErrorText":"Failed to create broadcast. Please try again.",
    "pleaseTryAfterSomeTimeErrorMessage":"Please try after sometime",
    "somethingWentWrong":"Something went wrong",
    "pleaseFillDetailsErrorMessage":"Please fill out all required fields correctly",
    "broadcastDate":"Created date",
    "lowText":"Low",
    "highText":"High",
    "currentYearText":"(Current)",
    "paginatePrevious":"Previous",
    "ellipsis":"  .....  ",
    "paginateNext":"Next",
    "AddFilterText":"Add filter",
    "removeFilter":"Clear filter",
    "previewLabel":"Preview",
    "noDataDisplay":"No data available"

}